<script>
	import { IconButton, Popover } from '@Shelly/shelly-design-system/index';

	import { Text } from '@Shelly/shelly-design-system/index';
	import {
		CALCULATION_OPERATORS,
		COMPARISON_OPERATORS,
	} from 'src/components/Scenes/helpers/math_based/math_processing_helpers';
	import { format } from 'svelte-i18n';
	let className = '';
	export { className as class };

	let showInstructions = false;
</script>

<Popover
	hideCloseBtn
	class={className}
	show={showInstructions}
	on:close={() => (showInstructions = false)}
>
	<IconButton
		aria-label={$format('button_math_instructions', { default: 'Math instructions' })}
		icon="fa-solid fa-circle-info"
		variant="help"
		class="text-primary"
		on:click={() => {
			showInstructions = !showInstructions;
		}}
		size="m"
	/>
	<svelte:fragment slot="customContent">
		<Text class="text-small">
			{$format('scenes_math_instructions_text_intro', {
				default:
					'Create powerful automations using math expressions to compare values and perform calculations:',
			})}
		</Text>
		<ul class="mt-s">
			<li>
				<Text class="text-small">
					{@html $format('scenes_math_instructions_text_comparison', {
						default: '<b>Comparison operators:</b> {operatos}',
						values: {
							operatos: COMPARISON_OPERATORS.join(', '),
						},
					})}
				</Text>
			</li>
			<li>
				<Text class="text-small">
					{@html $format('scenes_math_instructions_text_operators', {
						default: '<b>Calculation Operators:</b> {operatos}',
						values: {
							operatos: CALCULATION_OPERATORS.join(', '),
						},
					})}
				</Text>
			</li>
		</ul>

		<Text class="text-bold text-small">
			{$format('scenes_math_instructions_text_examples', {
				default: 'Examples:',
			})}
		</Text>
		<ul class="mt-s">
			<li>
				<Text class="text-small">
					{@html $format('scenes_math_instructions_text_example_1', {
						default: 'Compare the consumption of two devices: <b>A + B > 100</b>',
					})}
				</Text>
			</li>
			<li>
				<Text class="mb-s text-small">
					{@html $format('scenes_math_instructions_text_example_2', {
						default: 'Check if the device consumption is greater than 100W: <b>A > 100</b>',
					})}
				</Text>
			</li>
		</ul>
	</svelte:fragment>
</Popover>
